import { toDisplayLampPort } from './controllerDisplayName';

/**
 * Resolve display name for a virtual button's bound physical wall button.
 * Prefer absorb snapshot hostName, then live device name on that port, else "N번".
 * M02 번호는 실크 기준(포트 0 → 12번).
 *
 * @param {{ boundButton?: { controllerId?: string, port?: number|string }, boundButtonAbsorb?: { controllerId?: string, port?: number|string, hostName?: string } }} device
 * @param {Array<{ groups?: Array<{ devices?: object[] }> }>} zones
 * @returns {string|null} null if not bound
 */
export function resolveBoundButtonDisplayName(device, zones) {
  const bb = device?.boundButton;
  if (bb?.controllerId == null || bb?.port == null) return null;
  const port = Number(bb.port);
  if (!Number.isInteger(port)) return null;
  const serial = String(bb.controllerId);

  const absorb = device?.boundButtonAbsorb;
  if (
    absorb &&
    String(absorb.controllerId) === serial &&
    Number(absorb.port) === port &&
    typeof absorb.hostName === 'string' &&
    absorb.hostName.trim().length > 0
  ) {
    return absorb.hostName.trim();
  }

  for (const zone of zones || []) {
    for (const g of zone.groups || []) {
      for (const d of g.devices || []) {
        if (!d || d.isVirtual) continue;
        if (String(d.controllerId) !== serial) continue;
        const raw = d.item?.ports;
        const ports = Array.isArray(raw)
          ? raw.map((p) => Number(p)).filter((p) => Number.isInteger(p))
          : raw != null && Number.isInteger(Number(raw))
            ? [Number(raw)]
            : [];
        if (ports[0] === port && typeof d.name === 'string' && d.name.trim().length > 0) {
          return d.name.trim();
        }
      }
    }
  }

  return `${toDisplayLampPort(port, serial)}번`;
}
